/**
 * 상수
 */
export const MEMBERSHIP_SERVICE = {
  APP_MODE: {
    ENABLE: "enable",
    DISABLE: "disable",
  },
};
